import { methods } from "../../utils/axios";

export default class UtilsAPI {
  static getSectorList() {
    return methods.get('/clientSector');
  }
}